module.exports = __webpack_public_path__ + "img/prospx.72888326.png";